module.exports = __webpack_public_path__ + "img/III-207.1.1aab7ae9.svg";